<template lang="pug">
    
  v-btn.d-print-none(v-if='estado_del_documento  == "esperando"' color='primary' outlined rounded  @click='process({id,host})'  ) Notificar al proveedor
     
</template>
<script>
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
  data:()=>({
    host:window.location.host, 
  }),
  props:{
    estado_del_documento: String,
    id: String,
  },
  methods: {
    ...mapActions({
      process: 'Ordenes_de_compra/process',
    }),
  },
  computed: {
    ...mapState({
       Ordenes_de_compra:state=> state.Ordenes_de_compra,
    }),
  },
 
}
</script>
